export default __webpack_public_path__ + "static/media/Firebase.ecddc65b.svg";